<template>
  <div :class="['ms-form', 'ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomSelect :options="contractorOptions" label="Подрядчик" :required="true" optionValueKey="contractor_id"
          optionLabelKey="contractor_name" :value="selectedContractorValue"
          @change="(value) => onChange('contractor_id_new', value)"  />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import { getProviderRequestContractors } from "@/views/ProviderRequests/services";

export default {
  name: "provider-requests-contractor-form",
  components: { CustomModalFooter, CustomSelect },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        contractor_id: this.data?.body?.contractor_id || '',
        contractor_id_new: '',
        provider_request_id: this.data.body.provider_request_id || ''
      },
      contractorOptions: [],
    }
  },
  computed: {
    selectedContractorValue() {
      const selectedOption = this.contractorOptions.find(
        (option) => option.contractor_id === this.formData.contractor_id_new || option.contractor_id === this.formData.contractor_id
      );
      return selectedOption && selectedOption.contractor_name ? selectedOption.contractor_id : '';
    },
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
    async fetchContractors() {      
      this.contractorOptions = await getProviderRequestContractors();
    },
  },
  mounted() {
    this.fetchContractors();
  }
}
</script>